import React, { useState, useEffect } from "react";
import { Box, Typography, IconButton } from "@mui/material";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import {
  KeyboardArrowRight,
  KeyboardArrowDown,
  KeyboardArrowLeft,
  CalendarToday,
} from "@mui/icons-material";
import moment, { Moment } from "moment";
import { Colors } from "../../../theme";
import { useTranslation } from "react-i18next";

interface CustomDatePickerProps {
  onChange?: (startTime?: number, endTime?: number) => void;
  start_time?: number;
  end_time?: number;
}

const CustomDatePicker: React.FC<CustomDatePickerProps> = ({
  onChange,
  start_time,
  end_time,
}) => {
  const initialDate = start_time ? moment.unix(start_time) : moment();
  const [selectedDate, setSelectedDate] = useState<Moment | null>(initialDate);
  const {t} = useTranslation() as any

  useEffect(() => {
    if (start_time) {
      setSelectedDate(moment.unix(start_time));
    }
  }, [start_time]);

  const handleDateChange = (newDate: Moment | null) => {
    if (newDate) {
      const startTime = newDate.clone().startOf("day").unix();
      const endTime = newDate.endOf("day").unix();
      setSelectedDate(newDate);
      if (onChange) {
        onChange(startTime, endTime);
      }
    }
  };

  const handlePreviousDay = () => {
    if (selectedDate) {
      handleDateChange(selectedDate.clone().subtract(1, "days").startOf("day"));
    }
  };

  const handleNextDay = () => {
    if (selectedDate) {
      handleDateChange(selectedDate.clone().add(1, "days").startOf("day"));
    }
  };

  return (
    <Box
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
      }}
    >
      <Box
        style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          cursor: "pointer",
        }}
      >
        <IconButton style={{ color: Colors.black }} onClick={handlePreviousDay}>
          <KeyboardArrowLeft />
        </IconButton>
        <Typography
          onClick={() => handleDateChange(moment())}
          variant="subtitle2"
          color="#1e74c7"
        >
          {t("00_04_today")}
        </Typography>
        <IconButton style={{ color: Colors.black }} onClick={handleNextDay}>
          <KeyboardArrowRight />
        </IconButton>
        <CalendarToday sx={{ fontSize: "13px" }} />
        <DesktopDatePicker
          value={selectedDate}
          format="dddd - DD/MM/YYYY"
          onChange={handleDateChange}
          slots={{ openPickerIcon: KeyboardArrowDown }}
          slotProps={{
            textField: {
              variant: "standard",
              style: { width: "100%", fontSize: "13px" },
              sx: {
                "& .MuiInputLabel-root": {
                  fontSize: "12px",
                  fontWeight: "400",
                },
                "& .MuiInputBase-root::before, & .MuiInputBase-root::after": {
                  display: "none",
                },
                "& .MuiInputBase-input": {
                  fontSize: "13px",
                  fontWeight: "500",
                  pointerEvents: "none",
                },
              },
            },
          }}
        />
      </Box>
    </Box>
  );
};

export default CustomDatePicker;
